import { RedoFeatureNotificationCard } from "@redotech/redo-web/arbiter-components/feature-notification/redo-feature-notification-card";
import { memo } from "react";
import { OnboardingProps } from "../common";
import { CROSS_SELL_POPUP_URL } from "../index";

export const ManagedReturnsOnboarding = memo(function ManagedReturnsOnboarding({
  handleDismiss,
  handleComplete,
}: OnboardingProps) {
  const handleAction = () => {
    window.open(
      "https://calendly.com/dan-getredo/redo-managed-returns",
      "_blank",
    );
    handleComplete();
  };

  return (
    <RedoFeatureNotificationCard
      actionText="Learn more"
      description="Ship your returns to us. We'll receive, process, and liquidate."
      image={`${CROSS_SELL_POPUP_URL}/managed-returns-popup.png`}
      onAction={handleAction}
      onDismiss={handleDismiss}
      showBetaBadge
      title="Redo managed returns"
    />
  );
});
